<template>
  <div class="wrapper">
    <top-bar />
    <nav-bar />
    <mobile-nav-bar />
    <div class="content">
      <br />

      <div class="container-fluid" id="default-card">
        <h5 style="color:#039BE5;">Welcome {{ UserName }} !!</h5>
        <br />
        <slot />
      </div>
    </div>
    <default-footer />
  </div>
  <!-- <theme-settings /> -->
</template>

<script>
import NavBar from "@/components/header/NavBar.vue";
import TopBar from "@/components/header/TopBar.vue";
import MobileNavBar from "@/components/header/MobileNavBar.vue";
import DefaultFooter from "@/components/footer/DefaultFooter.vue";
export default {
  components: {
    DefaultFooter,
    NavBar,
    TopBar,
    MobileNavBar,
  },
  data() {
    return {
      UserName: "",
    };
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      var user = this.$session.get("user");
      user = user == (null || undefined) ? {} : user;
      console.log({ user });
      this.UserName =
        user.MemberFullName != "" ? user.MemberFullName : user.Username;
      console.log("UserName" + this.UserName);
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>

<style lang="scss" scoped>
</style>
